// client/src/pages/sections/disengagementApi.js
// Shared client helper: after a primary client is marked NLC, sweep in any
// related parties the user selected in the disengagement modal. POSTs to
// /api/diDisengageRelated, which judges each one against the caller: the client's
// Partner marks it NLC now, a Manager files a request the Partner must confirm,
// anyone else is skipped.
// Returns { marked, requested, skipped, errors } (throws on transport/HTTP failure).
// Show it with reportRelatedSweep() in nlcRequestUi.js.

export async function markRelatedParties({
  primaryContIndex,
  primaryClientCode,
  period,
  sourceSectionKey,
  disengagement,
  relatedParties,
}) {
  const list = Array.isArray(relatedParties) ? relatedParties : [];
  if (!list.length) return { marked: [], requested: [], skipped: [], errors: [] };

  const res = await fetch('/api/diDisengageRelated', {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      primaryContIndex: primaryContIndex != null ? String(primaryContIndex) : null,
      primaryClientCode: primaryClientCode || null,
      period,
      sourceSectionKey,
      disengagement,
      relatedClientCodes: list.map(p => p.clientCode),
    }),
  });
  if (!res.ok) throw new Error((await res.text()) || `HTTP ${res.status}`);
  return res.json();
}
